import { useState } from "react";
import { NavLink as NavLinkRRD, Link, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";
import {
  Nav,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  Collapse,
  Container,
} from "reactstrap";

import { notification } from "antd";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  const location = useLocation();

  const toggleCollapse = () => setCollapseOpen(!collapseOpen);
  const closeCollapse = () => setCollapseOpen(false);

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (!prop.show) return null;

      const fullPath = prop.layout + prop.path;

      const isActive = location.pathname.startsWith(fullPath);

      return (
        <NavItem key={key}>
          <NavLink
            tag={NavLinkRRD}
            to={fullPath}
            onClick={closeCollapse}
            className={`text-white navLink ${isActive ? "active" : ""}`}
          >
            <i className={prop.icon} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };

  const { routes, logo } = props;

  let navbarBrandProps;
  if (logo?.innerLink)
    navbarBrandProps = { tag: Link, to: logo.innerLink };
  else if (logo?.outterLink)
    navbarBrandProps = { href: logo.outterLink, target: "_blank" };

  const handleLogOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("UserId");

    notification.success({
      message: "Logout Successful",
      description: "You have been successfully logged out.",
      placement: "topRight",
    });

    setTimeout(() => {
      window.location.href = "/auth/login";
    }, 1000);
  };

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-blue"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <button className="navbar-toggler" onClick={toggleCollapse}>
          <span className="navbar-toggler-icon" />
        </button>

        {logo && (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        )}
        <Collapse navbar isOpen={collapseOpen}>
          <Nav navbar>
            {createLinks(routes)}

            <NavItem>
              <NavLink
                tag={NavLinkRRD}
                onClick={handleLogOut}
                className="text-white"
                to="#"
              >
                <i className="fas fa-sign-out-alt text-danger me-3" />
                Logout
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;